import translator from "@/translator";
import React, { useState, useEffect } from "react";
import { Card, Button, Typography, Space } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import BackButton from "@/note_office/shared/BackButton";
import BonusInfoModal from "./components/BonusInfoModal";
import ShareLinkCard from "@/note_office/shared/ShareLinkCard";

const t = translator("note_office.views.referrals.index_view.");
const { Title, Text } = Typography;

const IndexView = ({ referralsData }) => {
  const bonus = referralsData.bonus;
  const referralLink = referralsData.referral_link;
  const profileUrl = referralsData.profile_url;
  const [infoOpen, setInfoOpen] = useState(false);

  useEffect(() => {
    const bonus_modal = sessionStorage.getItem("referral_bonus_modal");

    if (!bonus_modal) {
      setInfoOpen(true);
      sessionStorage.setItem("referral_bonus_modal", "true");
    }
  }, []);

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <BackButton link={profileUrl} text={t("title")} />
      <BonusInfoModal open={infoOpen} onClose={() => setInfoOpen(false)} />
      <div className="referrals__section">
        <Card className="referrals__bonus-card">
          <Space className="referrals__space-row">
            <div>
              <Text className="referrals__bonus-label">{t("bonus_label")}</Text>
              <Title level={1} className="referrals__bonus-value">
                {bonus}
              </Title>
            </div>
            <InfoCircleOutlined
              className="referrals__info-icon"
              onClick={() => setInfoOpen(true)}
            />
          </Space>
        </Card>
        <Button
          type="primary"
          block
          className="referrals__use-bonus-btn"
          href="/note_office/referrals/new"
        >
          {t("use_bonuses")}
        </Button>

        <ShareLinkCard link={referralLink} shareText={t("share_text")} />
      </div>
    </div>
  );
};

export default IndexView;
